import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rec_doc2",
  "use": "icon-rec_doc2-usage",
  "viewBox": "0 0 56 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 56 18\" id=\"icon-rec_doc2\"><g fill=\"#16C66E\" fill-rule=\"evenodd\"><rect opacity=\".08\" width=\"56\" height=\"18\" rx=\"2\" /><text font-family=\"PingFangSC-Regular, PingFang SC\" font-size=\"11\">\n                                <tspan x=\"6\" y=\"13\">可开处方</tspan>\n                            </text></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol